function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M435 219c0-110-89-199-199-199S37 109 37 219s89 199 199 199 199-89 199-199zM236 333c-63 0-114-51-114-114s51-114 114-114 114 51 114 114-51 114-114 114zm142 115c14 15 42 44 42 44 16 16 43 17 60 1 17-17 18-44 1-61l-95-99c-16-17-43-17-60-1-17 17-18 44-1 61 0 0 35 37 53 55z"
})));